import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/AnalyticsAdaptersForm/GeneralForm'

export const GeneralPage = (): React.JSX.Element => {
  return <EditContainer />
}
